import Axios from 'axios'
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';

const state = {
  analysisArticleIrrelevant: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_ANALYSIS_ARTICLE_IRRELEVANT_BUSY: (state, payload) => {
    state.analysisArticleIrrelevant.isBusy = payload;
  },
  LOAD_ANALYSIS_ARTICLE_IRRELEVANT_SUCCESS: (state, payload) => {
    state.analysisArticleIrrelevant.data = payload.data.analysis_state == 5;
    state.analysisArticleIrrelevant.error = null;
  },
  LOAD_ANALYSIS_ARTICLE_IRRELEVANT_FAIL: (state, payload) => {
    state.analysisArticleIrrelevant.error = payload;
  },
  CLEAR_ANALYSIS_ARTICLE_IRRELEVANT: (state) => {
    state.analysisArticleIrrelevant.data = null;
    state.analysisArticleIrrelevant.error = null;
  },
};

const actions = {
  flagAsIrrelevant: ({ commit, rootState }, { projectId, articleId, irrelevant }) => {
    commit('LOAD_ANALYSIS_ARTICLE_IRRELEVANT_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios
      .put(`${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/irrelevant`, { irrelevant }, config)
      .then((response) => {
        commit('LOAD_ANALYSIS_ARTICLE_IRRELEVANT_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('LOAD_ANALYSIS_ARTICLE_IRRELEVANT_FAIL', error)
      })
      .finally(() => commit('LOAD_ANALYSIS_ARTICLE_IRRELEVANT_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};